
import Login from './views/Pages/Login'
import Page404 from './views/Pages/Page404/'
import Page500 from './views/Pages/Page500/'
import Page403 from './views/Pages/Page403/'

import Dashboard from './views/Dashboard/';
import MyAccount from './views/Pages/MyAccount';
import ChangePassword from './views/Pages/ChangePassword'
import TwoFASetting from './views/Pages/TwoFASetting'
import AdminUser from './views/Admin/AdminUser'
import ActivityLog from './views/Admin/ActivityLog'
import ActivityLogType from './views/Admin/ActivityLog/ActivityLogType'

import Setting from './views/Setting';
import Role from './views/Role';
import RoleEdit from './views/Role/RoleEdit';
import NganhHang from './views/NganhHang';
import NganhHangEdit from './views/NganhHang/NganhHangEdit';
import NhaCungCap from './views/NhaCC';
import NhaCungCapEdit from './views/NhaCC/NhaCCEdit';
import Kho from './views/Kho';
import KhoEdit from './views/Kho/KhoEdit';
import Products from './views/Products';
import ProductsEdit from './views/Products/ProductsEdit';
import NguoiDungKho from './views/NguoiDungKho';
import Orders from './views/Orders';
import Order from './views/Order';
import OrderDetails from './views/Order/OrderDetails';
import ChuongTrinh from './views/ChuongTrinh';
import ChuongTrinhEdit from './views/ChuongTrinh/ChuongTrinhEdit';
import ChuongTrinhProduct from './views/ChuongTrinh/ChuongTrinhProduct';
import NguoiDungRole from './views/NguoiDungRole';
import PermissionRole from './views/PermissionRole';
import KhachHangNhom from './views/KhachHangNhom';
import Khachhang from './views/KhachHang';
import KhachhangEdit from './views/KhachHang/KhachhangEdit';
import KhachhangUser from './views/KhachHang/KhachhangUser';
import TonKho from './views/TonKho';
import TonkhoEdit from './views/TonKho/TonKhoEdit';
import GuestReport from './views/Reports/GuestReport';
import ImportReport from './views/Reports/ImportReport';
import OrderReport from './views/Reports/OrderReport';
import SalaryReport from './views/Reports/SalaryReport';
import SalaryReportDetail from './views/Reports/SalaryReportDetail';
import SaleDetailReport from './views/Reports/SaleDetailReport';
import SaleTotalReport from './views/Reports/SaleTotalReport';
import SaleReport from './views/Reports/SaleReport';
import GiaoHangReport from './views/Reports/GiaoHangReport';

import Imports from './views/LsNhapKho';
import nhapkho from './views/NhapKho';
import nhapkhoEdit from './views/NhapKho/NhapKhoEdit';
import GiaoHang from './views/GiaoHang';
import GiaoHangEdit from './views/GiaoHang/GiaoHangEdit';
import CongNoNhanVien from './views/CongNoNhanVien';
import CongNoKH from './views/CongNoKhachHang/CongNoKhachHang';
import CongNoKHCt from './views/CongNoKhachHang/CongNoKhachHangCt';
import Contracts from './views/Contracts';
import EditContract from './views/Contracts/EditContract';
import TraHang from './views/TraHang';
import BacLuong from './views/BacLuong';
import BacLuongEdit from './views/BacLuong/BacLuongEdit';
import BacLuongUser from './views/BacLuong/BacLuongUser';
import NhomKhachHang from './views/NhomKhachHang';
import NhomKhachHangEdit from './views/NhomKhachHang/NhomKhachHangEdit';
import LichSuThanhToan from './views/LichSuThanhToan/LichSuThanhToan';
import CongNoNhanVienByKh from './views/CongNoKhachHang/CongNoNhanVienByKh';
import ProfitReport from './views/Reports/ProfitReport';
import LichSuTraThuong from './views/LichSuTraThuong/LichSuTraThuong';

// isHidden: để true nếu không hiện trên menu
// name: đặt tên để show trên breadcrumb
// ignore: để true để route bỏ qua không định tuyến, mục đích thêm vào chỉ để hiện thị name trên breadcrumb
const routes = [
  { path: "/login", isHidden: true, ignore: true, name: 'Đăng nhập', component: Login },
  { path: "/403", isHidden: true, ignore: true, name: 'Truy cập trái phép', component: Page403 },
  { path: "/404", isHidden: true, ignore: true, name: 'Không tìm thấy', component: Page404 },
  { path: "/500", isHidden: true, ignore: true, name: 'Lỗi server', component: Page500 },
  { path: "/dashboard", isHidden: true, name: 'Trang chủ', component: Dashboard },
  { path: "/changepassword", isHidden: true, name: '', component: ChangePassword },
  { path: "/myaccount", isHidden: true, name: 'Thông tin tài khoản', component: MyAccount },
  { path: "/twofasetting", isHidden: true, name: 'Bảo mật 2 lớp', component: TwoFASetting },
  { path: "/role-edit", isHidden: true, name: 'Thông tin nhóm người dùng', component: RoleEdit },
  { path: "/nganhhang-edit", isHidden: true, name: 'Thông tin nhóm sản phẩm', component: NganhHangEdit },
  { path: "/nhacungcap-edit", isHidden: true, name: 'Thông tin nhà cung cấp', component: NhaCungCapEdit },
  { path: "/kho-edit", isHidden: true, name: 'Thông tin kho', component: KhoEdit },
  { path: "/products-edit", isHidden: true, name: 'Thông tin sản phẩm', component: ProductsEdit },
  { path: "/chuong-trinh-edit", isHidden: true, name: 'Chi tiết chương trình', component: ChuongTrinhEdit },
  { path: "/chuong-trinh-product", isHidden: true, name: 'Danh sách sản phẩm theo chương trình KM', component: ChuongTrinhProduct },
  { path: "/nhap-kho-edit/:nhap?", isHidden: true, name: 'Sửa nhập hàng', component: nhapkhoEdit},
  { path: "/order/:type(1|2)", isHidden: true, name: 'Đặt đơn', component: Order },
  { path: "/order/1", ignore: true, isHidden: true, name: 'Đặt đơn', component: Order },
  { path: "/order/2", ignore: true, isHidden: true, name: 'Đặt đơn đại lý', component: Order },
  { path: "/order-edit/:type(1|2)/:id", isHidden: true, name: 'Sửa đơn hàng', component: Order },
  { path: "/order-edit/1", ignore: true, isHidden: true, name: 'Sửa đơn hàng', component: Order },
  { path: "/order-edit/2", ignore: true, isHidden: true, name: 'Sửa đơn đại lý', component: Order },
  { path: "/order-view/:type(1|2|3)/:id", isHidden: true, name: 'Xem đơn hàng', component: OrderDetails },
  { path: "/order-view/1", ignore: true, isHidden: true, name: 'Xem đơn hàng', component: OrderDetails },
  { path: "/order-view/2", ignore: true, isHidden: true, name: 'Xem đơn hàng đại lý', component: OrderDetails },
  { path: "/order-view/3", ignore: true, isHidden: true, name: 'Xem đơn trả hàng', component: OrderDetails },
  { path: "/nhap-kho", isHidden: true, name: 'Nhập hàng', component: nhapkho },
  { path: "/khachhang-edit", isHidden: true, name: 'Thông tin khách hàng', component: KhachhangEdit },
  { path: "/khachhang-user", isHidden: true, name: 'Khách hàng - quản lý', component: KhachhangUser },
  { path: "/tonkho-edit", isHidden: true, name: 'Cập nhật số lượng sản phẩm tồn kho', component: TonkhoEdit },
  { path: "/giaohang-edit", isHidden: true, name: 'Chi tiết giao hàng', component: GiaoHangEdit },
  { path: "/congnokhct", isHidden: true, name: 'Công nợ theo hóa đơn', component: CongNoKHCt },
  { path: "/chi-tiet-hop-dong", isHidden: true, name: 'Thông tin hợp đồng', component: EditContract },
  { path: "/tra-hang/:type(1|2)/:id", isHidden: true, name: 'Đơn trả hàng', component: TraHang },
  { path: "/tra-hang/1", ignore: true, isHidden: true, name: 'Đơn trả hàng', component: TraHang },
  { path: "/tra-hang/2", ignore: true, isHidden: true, name: 'Đơn trả hàng', component: TraHang },
  { path: "/bacluong-edit", isHidden: true, name: 'Thông tin bậc lương', component: BacLuongEdit },
  { path: "/bacluong-user", isHidden: true, name: 'Thông tin bậc lương - người dùng', component: BacLuongUser },
  { path: "/nhomkhachhang-edit", isHidden: true, name: 'Thông tin nhóm khách hàng', component: NhomKhachHangEdit },

  { path: "/activities", name: 'Lịch sử hoạt động', component: ActivityLog },
  { path: "/activity-types", name: 'Loại hoạt động', component: ActivityLogType },
  { path: "/orders/:type(1|2)", name: 'Đơn hàng', component: Orders },
  { path: "/orders/1", ignore: true, name: 'Đơn hàng', component: Orders },
  { path: "/orders/2", ignore: true, name: 'Đơn đại lý', component: Orders },
  { path: "/orders/:type(1|2)/:status", name: 'Đơn hàng', component: Orders },
  { path: "/imports", name: 'Danh sách phiếu nhập', component: Imports },
  { path: "/tonkho", name: 'Danh sách sản phẩm tồn kho', component: TonKho },
  { path: "/congnokh", name: 'Công nợ khách hàng', component: CongNoKH },
  { path: "/congno-nhanvien", name: 'Công nợ nhân viên', component: CongNoNhanVien },
  { path: "/congnonv", name: 'Công nợ nhân viên', component: CongNoNhanVienByKh },
  { path: "/lichsu-thanhtoan", name: 'Lịch sử thanh toán', component: LichSuThanhToan },
  { path: "/khachhang", name: 'Quản lý khách hàng', component: Khachhang },
  { path: "/giaohang", name: 'Giao hàng', component: GiaoHang },
  { path: "/users", name: 'Danh sách nhân viên', component: AdminUser },
  { path: "/roles", name: 'Quản lý nhóm người dùng', component: Role },
  { path: "/nganhhang", name: 'Quản lý nhóm sản phẩm', component: NganhHang },
  { path: "/nhacungcap", name: 'Quản lý nhà cung cấp', component: NhaCungCap },
  { path: "/products", name: 'Quản lý sản phẩm', component: Products },
  { path: "/kho", name: 'Quản lý kho', component: Kho },
  { path: "/nguoidung-kho", name: 'Thêm người dùng vào kho', component: NguoiDungKho },
  { path: "/nguoidung-role", name: 'Thêm người dùng vào nhóm', component: NguoiDungRole },
  { path: "/permission-role", name: 'Thêm quyền cho nhóm người dùng', component: PermissionRole },
  { path: "/chuong-trinh", name: 'Chương trình khuyến mãi', component: ChuongTrinh },
  { path: "/khachhang-nhom", name: 'Khách hàng - nhóm', component: KhachHangNhom },
  { path: "/import-report", name: 'Báo cáo nhập hàng', component: ImportReport },
  { path: "/order-report", name: 'Báo cáo đơn hàng', component: OrderReport },
  { path: "/guest-report", name: 'Báo cáo theo khách hàng', component: GuestReport },
  { path: "/sale-detail-report", name: 'Báo cáo chi tiết khách hàng', component: SaleDetailReport },
  { path: "/sale-total-report", name: 'Độ phủ nghành hàng', component: SaleTotalReport },
  { path: "/sale-report", name: 'Báo cáo doanh số', component: SaleReport },
  { path: "/giaohang-report", name: 'Thống kê giao hàng', component: GiaoHangReport },
  { path: "/hop-dong", name: 'Danh sách hợp đồng', component: Contracts },
  { path: "/setting", name: 'Cấu hình hệ thống', component: Setting },
  { path: "/bacluong", name: 'Bậc lương', component: BacLuong },
  { path: "/nhomkhachhang", name: 'Nhóm khách hàng', component: NhomKhachHang },
  { path: "/salary-report", name: 'Báo cáo lương nhân viên', component: SalaryReport },
  { path: "/salary-report-detail", name: 'Báo cáo chi tiết lương nhân viên', component: SalaryReportDetail },
  { path: "/profit-report", name: 'Báo cáo lợi nhuận bán hàng', component: ProfitReport },
  { path: "/lichsu-trathuong", name: 'Lịch sử trả thưởng', component: LichSuTraThuong },
]

export default routes


// WEBPACK FOOTER //
// ./src/routes.js